export const GITHUB_URL = "https://github.com/mkayander/dStruct";
